import React, { useState, useEffect } from 'react';
import '.././styles/trivia.css';

const questions = [
    {
        question: "Which show choir was the four-time Superbowl halftime headlining act?",
        options: ["Heart of Indiana", "Up with People", "Solid Gold Minstrels", "State Street Singers"],
        answer: "Up with People"
    },
    {
        question: "First nationally televised high school show choir competition",
        options: ["Diamond Bar High School Invitational, California", "Totino-Grace High School Spectacular, Minnesota", "Bishop Luers High School Invitational, Indiana", "Lin-Marr High School Super Nova Invitational, Iowa"],
        answer: "Bishop Luers High School Invitational, Indiana"
    },
    {
        question: "What is the first song the show choir performs called?",
        options: ["Prelude", "Overture", "Sequence Number", "Opener"],
        answer: "Opener"
    },
    {
        question: "Which of the following famous celebrities was not in a high school show choir?",
        options: ["Ryan Gosling", "Ashton Kutcher", "Lance Bass", "Blake Lively"],
        answer: "Ryan Gosling"
    },
    {
        question: "What is the role of a show choir “pit”?",
        options: ["The place where the competition’s adjudicators sit and judge from", "The live band that accompanies the show choirs performance", "Where dirty costumes are placed for professional cleaning", "The name of the crew that set’s up props before the show choir takes the stage"],
        answer: "The live band that accompanies the show choirs performance"
    },
    {
        question: "What is the typical voice arrangement in a mixed-gender show choir who sings the highest vocal part?",
        options: ["Soprano II", "Tenor I", "Soprano I", "Tenor II"],
        answer: "Soprano I"
    },
    {
        question: "What is the name of the award often given to the best dance group in a show choir competition?",
        options: ["Best Dance Numbers", "Best Moves to Music", "Best Choreography", "Best Swing Steppers"],
        answer: "Best Choreography"
    },
    {
        question: "What company is most famous for making show choir risers and performance platforms?",
        options: ["Conn-Selmer Corporation, Indiana", "Hal Leonard Corporation, Wisconsin", "Steinway and Sons, New York", "Wenger Corporation, Minnesota"],
        answer: "Wenger Corporation, Minnesota"
    },
    {
        question: "What is the musical composition you may see the show choir director conduct?",
        options: ["The Opener", "The Ballad", "The Closer", "The Most Difficult Musical Selection"],
        answer: "The Ballad"
    },
    {
        question: "What is the most major challenge for show choirs during live performances?",
        options: ["Forgetting the words to the songs", "Balancing strong vocals while executing intricate choreography", "Not having enough time for a costume change", "The drums are too loud"],
        answer: "Balancing strong vocals while executing intricate choreography"
    },
];

const GameOverScreen = ({ score, totalQuestions, level, goToLevel2 }) => {
    const percentage = (score / totalQuestions) * 100;

    return (
        <div className="GameOverScreen">
            <h2>Game Over</h2>
            <p>Your final score is {score}</p>
            <p>Percentage: {percentage}%</p>
            {level === 1 && percentage > 90 && (
                <button onClick={goToLevel2}>Go to Level 2</button>
            )}
        </div>
    );
};




const TriviaGame = () => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [gameOver, setGameOver] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [answered, setAnswered] = useState(false);

    const totalQuestions = questions.length;

    const playSound = () => {
        const audio = new Audio('/sounds/trivia-select.mp3');
        audio.play();
    }

    const handleAnswer = (selectedOption) => {
        playSound();

        if (selectedOption === questions[currentQuestionIndex].answer) {
            setScore(score + 1);
        }

        setSelectedOption(selectedOption);
        setAnswered(true);

        if (currentQuestionIndex < questions.length - 1) {
            setTimeout(() => {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
                setSelectedOption(null);
                setAnswered(false);
            }, 1000);
        } else {
            setGameOver(true);
        }
    };

    const screenWidthChange = 768;
    const [mobileBG, setMobileBG] = useState(window.innerWidth <= screenWidthChange);


    useEffect(() => {
        const handleResize = () => {
            setMobileBG(window.innerWidth <= screenWidthChange);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (gameOver) {
            const timeoutId = setTimeout(() => {
                window.location.reload();
            }, 30000);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [gameOver]);

    return (
        <div
            id='trivia-outer'
            style={{
                width: '100%',
                backgroundImage: score === 10 ? `url('images/triv-win-img.jpg')` : `none`,
            }}
        >

            {score === 10 ? (
                <div className='perfect-win-title'>
                    <h1 style={{ fontSize: '40px' }}>10/10 Perfect Score!</h1>
                </div>
            ) : (
                <></>
            )

            }

            <div id='trivia-bg'
                style={{
                    backgroundImage:
                        score === 10
                            ? 'none'
                            : mobileBG
                                ? `url('images/trivia-bg-mob.jpg')`
                                : `url('images/trivia-bg.jpg')`,
                }}
            >


                <div
                    className={`TriviaGame ${score === 10 ? 'triv-perfect-score' : ''}`}

                >
                    <h1>Trivia Game</h1>
                    {gameOver ? (
                        <GameOverScreen score={score} totalQuestions={totalQuestions} />
                    ) : (
                        <div>
                            <p className="Question">Question {currentQuestionIndex + 1}: {questions[currentQuestionIndex].question}</p>
                            <div className="AnswerOptions">
                                {questions[currentQuestionIndex].options.map((option, index) => (
                                    <div
                                        key={index}
                                        className="AnswerOptionBox"
                                        onClick={() => handleAnswer(option)}
                                        style={{ backgroundColor: selectedOption === option && option !== questions[currentQuestionIndex].answer ? 'red' : 'transparent' }}
                                    >
                                        <p style={{ color: selectedOption === option && option !== questions[currentQuestionIndex].answer ? 'black' : 'white' }}>
                                            {option}
                                        </p>
                                    </div>
                                ))}
                            </div>
                            {answered && (
                                <div className="CorrectAnswerBox" style={{ backgroundColor: 'green', color: 'white', padding: '10px', marginTop: '10px' }}>
                                    Correct Answer: {questions[currentQuestionIndex].answer}
                                </div>
                            )}
                        </div>
                    )}
                    <p style={{ padding: '60px' }}>Score: {score}</p>
                </div>

            </div>


        </div>
    );
};

export default TriviaGame;


